import { render, staticRenderFns } from "./skipIpCell.vue?vue&type=template&id=1664feee&scoped=true"
import script from "./skipIpCell.vue?vue&type=script&lang=js"
export * from "./skipIpCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1664feee",
  null
  
)

export default component.exports